<template>
    <div class="dateTime" v-text="nowDate">
    </div>
</template>

<script>
    let timer = null

    export default {
        name: 'DateTime',
        data() {
            return {
                nowDate: "",
            }
        },
        computed: {

        },
        mounted() {
            timer = setInterval(()=> {
                this.nowDate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
            }, 1000);
        },
        components: {

        },
        props: {

        },
        beforeDestroy() {
            clearInterval(timer)
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorTopTime.vue